module.exports = __webpack_public_path__ + "img/mile5.01d63eea.jpg";